import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "extension_active",
  "use": "extension_active-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"extension_active\"><path fill-rule=\"evenodd\" d=\"M1 3c0-.552.445-1 .993-1h16.014c.548 0 .993.445.993 1v14c0 .552-.445 1-.993 1H1.993A.995.995 0 0 1 1 17V3Zm0 4h18v1H1V7Zm12 1h1v10h-1V8ZM3 4h1v1H3V4Zm2 0h1v1H5V4Zm2 0h1v1H7V4Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol